import { render, staticRenderFns } from "./VaimoButton.vue?vue&type=template&id=1fa58d1a&scoped=true&"
import script from "./VaimoButton.vue?vue&type=script&lang=ts&"
export * from "./VaimoButton.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoButton.vue?vue&type=style&index=0&id=1fa58d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa58d1a",
  null
  
)

export default component.exports